export default "__VITE_ASSET__DGHGAWVF__"